import React from 'react';
import { connect } from 'react-redux';
import { Form, Control, Errors } from 'react-redux-form';
import InputFields from '../../InputFields';
import './style.css';
import IconRisk from '../../../global/img/signup/human.svg';
import IconRecovery from '../../../global/img/signup/time.svg';
import IconDate from '../../../global/img/signup/date.svg';
import IconStartSit from '../../../global/img/signup/medical.svg';
import IconScience from '../../../global/img/signup/science.svg';
import IconArticles from '../../../global/img/signup/Indepth.svg';
import IconEasy from '../../../global/img/signup/EasytoUnderstand.svg';
import IconFreeBadge from '../../../global/img/signup/Free.svg';
import QuoteIcon from '../../../global/img/signup/Quate.svg';

const benefitItems = [
	{ label: 'Real-Time Injury Risk Analysis for NFL, NBA, and Soccer', iconSrc: IconRecovery },
	{ label: 'Projected Recovery Times', iconSrc: IconDate },
	{ label: 'Start/Sit Recommendations Based on Medical Data', iconSrc: IconStartSit },
	{ label: 'Science-Backed Injury Analysis for your DFS & Fantasy Teams', iconSrc: IconScience },
	{ label: 'In-depth Articles on Key Injuries & Outlooks', iconSrc: IconArticles },
	{ label: 'Easy to Understand!', iconSrc: IconEasy }
];

const sportsOptions = [
	{ label: 'NFL', value: 'NFL' },
	{ label: 'NBA', value: 'NBA' },
	{ label: 'EPL', value: 'EPL' },
	{ label: 'La Liga', value: 'La Liga' },
	{ label: 'IPL', value: 'IPL' }
];

const BenefitIcon = ({ src, alt }) => {
	return <img src={src} alt={alt} className='signupv1-benefit-img' />;
};

// Badge placeholder (FREE)
const BadgeIcon = () => <img src={IconFreeBadge} alt='Free badge' className='signupv1-badge-img' />;


const BenefitsColumn = () => (
	<div className='signupv1-benefits'>
		<p className='signupv1-eyebrow'>Why Join?</p>
		<ul className='signupv1-benefits-list'>
			{benefitItems.map((item) => (
				<li key={item.label} className='signupv1-benefit'>
					<span className='signupv1-benefit-icon'>
						<BenefitIcon src={item.iconSrc} alt={item.label} />
					</span>
					<span className='signupv1-benefit-copy'>{item.label}</span>
				</li>
			))}
		</ul>
		<div className='signupv1-free-row'>
			<BadgeIcon />
			<div className='signupv1-free'>ALWAYS FREE</div>
		</div>
		<div className='signupv1-quote-bubble'>
			<div className='signupv1-avatar-stack'>
				<img src={IconRisk} alt='avatar' className='signupv1-avatar-image' />
				<div className='signupv1-avatar-name'>Mike F.</div>
			</div>
			<div className='signupv1-quote-content'>
				<p className='signupv1-quote'>
									<img src={QuoteIcon} alt='quote' className='signupv1-quote-icon' />
					Two of my biggest DFS wins came because I benched guys with low Health Scores. <b>Inside Injuries</b> keeps me from getting burned by surprise underperformances.
				</p>
			</div>
		</div>
	</div>
);

const FavoriteSportSelector = () => (
	<div className='inputCol'>
		<label className='signupv1-label'>Choose your favorite</label>
		<div className='signupv1-radio-group'>
			{sportsOptions.map((sport) => (
				<label key={sport.value} className='signupv1-radio'>
					<Control.radio model='.favorite_sport' value={sport.value} validators={{ required: (val) => !!val }} />
					<span>{sport.label}</span>
				</label>
			))}
		</div>
		<Errors className='formInputError' model='.favorite_sport' messages={{ required: 'Required*' }} show={{ touched: true, focus: false }} />
	</div>
);

const MarketingOptIn = () => (
	<label className='signupv1-checkbox'>
		<Control.checkbox model='.marketing_opt_in' />
		<span>Yes, I want to receive updates and special offers via email.</span>
	</label>
);

const SignupCard = ({ handleSignup, message }) => (
	<div className='signupv1-card'>
		<div className='signupv1-card-header'>
			<p className='signupv1-kicker'>Create Your Free Account</p>
		</div>
		{message ? <p className='signupv1-error'>{message}</p> : null}
		<Form model='userActions.signup' onSubmit={handleSignup} initialState={{ favorite_sport: 'NFL', marketing_opt_in: false }}>
			<div className='inputCol'>
				<InputFields model='.email' inputType='text' type='email' placeholder='email address' label='Email' />
			</div>
			<div className='inputCol'>
				<InputFields model='.password' inputType='text' type='password' placeholder='password' label='Password' />
			</div>
			<FavoriteSportSelector />
			<MarketingOptIn />
			<Control.button model='userActions.signup' className='signupv1-submit' type='submit'>
				UNLOCK MY EDGE NOW
			</Control.button>
			<p className='signupv1-login-below' style={{ textAlign: 'center', marginTop: 8 }}>
				Already have an account?
				<a href='/login' className='signupv1-login-link' style={{ marginLeft: 6 }}>Login here</a>
			</p>
			<p className='signupv1-footnote'>Always Free | Real-Time Algorithms</p>
		</Form>
	</div>
);

function SignupV1({ dispatch, userActions }) {
	const handleSignup = (data) => {
		dispatch({
			type: 'SIGNUP',
			payload: data
		});
	};

	const signupMessage = userActions?.signupError && userActions?.message?.message ? userActions.message.message : '';

	return (
		<section className='signupv1'>
			<div className='signupv1-shell'>
			
				<div className='signupv1-grid'>
					<BenefitsColumn />
					<SignupCard handleSignup={handleSignup} message={signupMessage} />
				</div>
			</div>
		</section>
	);
}

const mapStateToProps = (state) => ({
	userActions: state.userActions
});

export default connect(mapStateToProps)(SignupV1);
